import { render } from "./FooterPoweredBySellsy.vue?vue&type=template&id=5d78eb16&scoped=true"
import script from "./FooterPoweredBySellsy.vue?vue&type=script&lang=js"
export * from "./FooterPoweredBySellsy.vue?vue&type=script&lang=js"

import "./FooterPoweredBySellsy.vue?vue&type=style&index=0&id=5d78eb16&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d78eb16"]])

export default __exports__